import { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import Overlay from 'react-bootstrap/Overlay';
import cx from 'classnames';

import * as URL from '../../lib/router/url';
import * as actions from '../../modules/auth/store/actions';
import ProfileInfo from './ProfileInfo';
import Can from '../../modules/permissions/abilities/Can';
import FeedbackModal from '../../modules/feedback/components/FeedbackModal';

interface ProfileMenuProps {
  /** logout из Redux (auth actions). */
  logout?: (...args: any[]) => any;
  /** Минимальный вид кнопки-профиля (без полного имени). */
  minimal?: boolean;
  /** Мобильная раскладка кнопки-профиля. */
  mobile?: boolean;
}

const ProfileMenu = ({ logout, minimal, mobile }: ProfileMenuProps) => {
  const overlayRef = useRef<HTMLDivElement | null>(null);
  const [show, setShow] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  return (
    <>
      { /* trigger='click' убран: пропс OverlayTrigger, низкоуровневый Overlay его игнорировал (показ — через show) */ }
      <Overlay
        placement='top-end'
        target={ overlayRef.current }
        show={ show }
        onHide={ () => setShow(false) }
        flip
        rootClose
      >
        { ({
          // placement,
          // scheduleUpdate,
          // arrowProps,
          // outOfBoundaries,
          // show: _show,
          ...p
        }) => (
          <nav className='profile-overlay' { ...p }>
            <div className='profile-overlay__bio'>
              <ProfileInfo variant='light' showFullInfo />
            </div>
            <div className='profile-overlay__menu'>
              <LinkContainer to={ URL.URL_PERSONAL_STATISTIC }>
                <button
                  className='profile-overlay__button'
                  type='button'
                  onClick={ () => setShow(false) }
                >
              Статистика
                </button>
              </LinkContainer>
              <Can do='available' on='stream.account.settings'>

                <LinkContainer to={ URL.URL_STREAM_BALANCE }>
                  <button
                    className='profile-overlay__button'
                    type='button'
                    onClick={ () => setShow(false) }
                  >
              Баланс стрима
                  </button>
                </LinkContainer>
              </Can>

              <Can do='available' on='reference.max.channel'>

                <LinkContainer to={ URL.URL_MAX_CHANNEL }>
                  <button
                    className='profile-overlay__button'
                    type='button'
                    onClick={ () => setShow(false) }
                  >
              Список каналов MAX
                  </button>
                </LinkContainer>
              </Can>

              <LinkContainer to={ URL.URL_CONFIG }>
                <button
                  className='profile-overlay__button'
                  type='button'
                  onClick={ () => setShow(false) }
                >
              Настройки аккаунта
                </button>
              </LinkContainer>
              <LinkContainer to={ URL.URL_CONFIG_WORKSPACE }>
                <button
                  className='profile-overlay__button'
                  type='button'
                  onClick={ () => setShow(false) }
                >
              Настройки рабочего места
                </button>
              </LinkContainer>
              <button
                className='profile-overlay__button'
                type='button'
                onClick={ () => {
                  setShowFeedback(true);
                  setShow(false);
                } }
              >
              Создать обращение
              </button>
              <LinkContainer to={ URL.URL_FEEDBACK_MY }>
                <button
                  className='profile-overlay__button'
                  type='button'
                  onClick={ () => setShow(false) }
                >
              Мои обращения
                </button>
              </LinkContainer>
              <button
                type='button'
                className='profile-overlay__button'
                onClick={ () => {
                  logout();
                  setShow(false);
                } }
                onKeyPress={ () => {
                  logout();
                  setShow(false);
                } }
              >
            Выход
              </button>
            </div>
          </nav>
        ) }
      </Overlay>
      <div
        className={
          cx(
            'profile-top-button',
            'ml-auto',
            'my-auto',
            'p-2',
            'p-md-0 mr-1',
            'float-end',
            { 'is-mobile': mobile }
          )
        }
        role='button'
        ref={ overlayRef }
        onClick={ () => setShow(!show) }
        onKeyUp={ () => setShow(!show) }
        tabIndex={ 0 }
        aria-label='ProfileInfo'
      >
        <ProfileInfo minimal={ minimal } />
      </div>
      { showFeedback && <FeedbackModal onClose={ () => setShowFeedback(false) } /> }
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    logout: payload => dispatch(actions.logout(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ProfileMenu);
